var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { ListDiffSpec, } from '../../parsing/UiTypesSpec';
import { applyDiff, convertToListDiff, EMPTY_DIFF, } from '../../utils/ListDiffUtils';
import { CopyInputSettings } from './CopyInputSettings';
import { UISelect } from './UISelect';
var parseValues = function (values) {
    return values
        .flatMap(function (v) {
        if (v.startsWith('[') && v.endsWith(']')) {
            return v.slice(1, -1);
        }
        return v;
    })
        .flatMap(function (v) {
        return v
            .split(',')
            .map(function (v) { return v.trim(); })
            .filter(function (v) { return v; })
            .map(function (v) {
            return v.startsWith('"') && v.endsWith('"') ? v.slice(1, -1) : v;
        });
    });
};
export var StringListInputComponent = function (_a) {
    var _b, _c, _d;
    var input = _a.input, config = _a.config, theme = _a.theme, onChange = _a.onChange, readonly = _a.readonly;
    console.log('theme', theme);
    var spec = ListDiffSpec.optional().default(EMPTY_DIFF);
    var configuredDiff = spec.parse((_b = config === null || config === void 0 ? void 0 : config.inputConfigs) === null || _b === void 0 ? void 0 : _b[input.macroName]);
    var themeDiff = spec.parse((_d = (_c = theme === null || theme === void 0 ? void 0 : theme.config) === null || _c === void 0 ? void 0 : _c.inputConfigs) === null || _d === void 0 ? void 0 : _d[input.macroName]);
    var currentValues = applyDiff(input.default, [themeDiff, configuredDiff]);
    var options = input.default.map(function (option) {
        if (typeof option === 'string') {
            return {
                label: option,
                value: option,
            };
        }
        return option;
    });
    return (_jsxs("div", { children: [_jsxs("div", __assign({ style: { display: 'flex', gap: 2, alignItems: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "h6", color: "primary" }, { children: input.label })), _jsx(CopyInputSettings, { input: input, configToCopy: currentValues, onChange: onChange })] })), _jsx(UISelect, { sx: {
                    width: '100%',
                }, disabled: readonly, options: options, label: input.label, multiple: true, freeSolo: true, value: currentValues.map(function (value) {
                    if (typeof value === 'string') {
                        var found = options.find(function (o) { return o.value === value; });
                        if (found) {
                            return found;
                        }
                        return {
                            label: value,
                            value: value,
                        };
                    }
                    return value;
                }), onChange: function (newValue) {
                    var values = (newValue || []).map(function (option) { return option.value; });
                    var splitValues = parseValues(values);
                    onChange(convertToListDiff(splitValues, applyDiff(input.default, [themeDiff])));
                } })] }));
};
